import { ErrorStore } from '@/entities/error/model/ErrorStore';
import { fetchBets, fetchMatch, fetchMatches, setBet } from '@/shared/api/api';
import { makeAutoObservable, runInAction } from 'mobx';
import { IBet, IMatch, ISetBet, Phase } from '../types';
import { IUser } from '@/entities/user/types';
import dayjs from '@/shared/lib/dayjs';
import {RootStore} from "@/app/providers/StoreProvider";

export class ForecastStore {

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    private get errorStore() {
        return this.rootStore.errorStore;
    }

    matches:IMatch[] = [];
    bets:IBet[] = [];

    bet:ISetBet = {
        homeScore: 0,
        awayScore: 0,
        oviGoals: 0,
        oviHelps: 0
    }

    loading = false;

    setHomeScore = (score:number) =>{
      this.bet.homeScore = score;
    }
    setAwayScore = (score:number) =>{
      this.bet.awayScore = score;
    }

    setOviGoals = (score:number) =>{
      this.bet.oviGoals = score;
    }
    setAOviHelps = (score:number) =>{
      this.bet.oviHelps = score;
    }


    isBet = (user:IUser) => {
      return this.bets.find(x=>x.userId == user.id);
    }

    getActualMatch = ()=>{
      if(this.matches.length == 0) return null;
      const match = this.matches.filter(x => x.actual);

      if(match){
        return match[0];
      }
      return null;
    }
    getWithoutActualMatch = ()=>{
      if(this.matches.length == 0) return [];
      return this.matches.filter(x => !x.actual);
    }
    isBetFilled = () => {
        return !(this.bet.homeScore == 0 &&
            this.bet.awayScore == 0 &&
            this.bet.oviGoals == 0 &&
            this.bet.oviHelps == 0);
    }
    resetBet = () =>{
        const bet = {
            homeScore: 0,
            awayScore: 0,
            oviGoals: 0,
            oviHelps: 0
        };
        this.bet = {...bet};
    }

    getMatches = async() => {
        this.loading = true;
        try {
          const matches = await fetchMatches();
          if(matches.success){
            runInAction(() => {
              this.matches = matches.data.sort((a,b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf());
            });
          }else{
            this.errorStore.setError(matches.error);
          }
        } finally {
          runInAction(() => {
            this.loading = false;
          });
        }
    }
    getMatch = async(id:string) => {
        this.loading = true;
        try {
          const match = await fetchMatch(id);
          if(match.success){
            return match.data;
          }else{
            this.errorStore.setError(match.error);
            return null;
          }
        } finally {
          runInAction(() => {
            this.loading = false;
          });
        }
    }

    getBets = async(id:number) => {
        this.loading = true;
        try {
          const bets = await fetchBets(id);
          if(bets.success){
            runInAction(() => {
              this.bets = bets.data.sort((a,b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf());
            });
          }else{
            this.errorStore.setError(bets.error);
          }
        } finally {
          runInAction(() => {
            this.loading = false;
          });
        }
    }

    setBet = async(id:number) => {
       if(!this.isBetFilled()){
            return false;
       }

       this.loading = true;
       try {
         const match = await setBet(id,this.bet);
         if(match.success){
          runInAction(() => {
            this.getBets(id);
          })
         }else{
           this.errorStore.setError(match.error);
         }
       } finally {
         runInAction(() => {
           this.loading = false;
         });
       }

    }

}
